type UpdateCallback = () => void;
type DrawCallback = () => void;

export class Task {
  private readonly updateCallbacks: UpdateCallback[] = [];
  private readonly drawCallbacks: DrawCallback[] = [];

  public update(callback: UpdateCallback) {
    this.updateCallbacks.push(callback);
  }

  public beginUpdate() {
    this.updateCallbacks.forEach(callback => callback());
  }

  public draw(callback: DrawCallback) {
    this.drawCallbacks.push(callback);
  }

  public beginDraw() {
    this.drawCallbacks.forEach(callback => callback());
  }
}
